import React from 'react'
import "./Footer.css"
function Footer() {
  return (
    <div>
      <div className='container ic1'>
        <h2>Frequently Asked Questions</h2>
        <hr style={{ width: "93%" }} />
        <h5>Please contact us if you cannot find an answer to your question.</h5>
      </div>
      <div className='container ic2'>
        <div class="accordion accordion-flush" id="accordionFlushExample">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                What does an educational consultant do?
              </button>
            </h2>
            <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">An educational consultant, also called a higher education consultant, assists students and their parents in planning for college and financial aid. </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                When should we meet with you?
              </button>
            </h2>
            <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">While we can step in to help a family at any point in their planning journey, the best time to contact us is in your student's freshman year. </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                Can you guarantee that my child will get into their first choice school?
              </button>
            </h2>
            <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
              <div class="accordion-body">No one can ethically offer this guarantee. However, we can work with your child to shape their activities and application to give them their very best chance.</div>
            </div>
          </div>
        </div>

      </div>
      <div class="footer-copyright text-center">
        <p>Copyright © 2023 Jupor Group - All Rights Reserved.</p>
      </div>
    </div>
  )
}

export default Footer
